import { ChevronLeft, ChevronRight } from "lucide-react";
import { cn } from "~/utils/cn";
import { useSidebar } from "~/components/ui/sidebar";

/**
 * A button to toggle the sidebar.
 * @description This button is used to toggle the sidebar.
 * It is used to toggle the sidebar when the user clicks on it.
 * It is also used to toggle the sidebar when the user presses the keyboard shortcut.
 * @example
 * <ToggleSidebarButton />
 * @returns A button to toggle the sidebar
 */
export const ToggleSidebarButton = () => {
    const { state, toggleSidebar } = useSidebar();
    const isCollapsed = state === "collapsed";

    return (
        <button
            onClick={toggleSidebar}
            className={cn(
                "absolute top-1/2 -translate-y-1/2 z-20 flex h-6 w-6 items-center justify-center rounded-full border bg-background shadow-sm transition-all hover:bg-accent",
                isCollapsed ? "-right-3" : "-right-3"
            )}
            title={isCollapsed ? "Expand sidebar" : "Collapse sidebar"}
        >
            {isCollapsed ? (
                <ChevronRight className="h-3 w-3" />
            ) : (
                <ChevronLeft className="h-3 w-3" />
            )}
        </button>
    )
}